import { createContext } from 'react'
import { BacktestFolder } from '../../../hooks/useBacktestFolders'

// Deliberately separate from ShowcaseContext (a much larger context with many
// component imports) rather than exporting that context directly: this file
// has no imports beyond React and a type, so consumers that render outside
// ShowcaseProvider — e.g. useFavoriteBacktest, used from tabs that have no
// concept of folders — can safely import it without a circular dependency
// back through ShowcaseContext's own component tree.
export interface FolderMembershipContextValue {
  folders: BacktestFolder[]
  moveBacktestToFolder: (backtestId: string, targetFolderId: string | null) => Promise<void>
}

export const FolderMembershipContext = createContext<FolderMembershipContextValue | undefined>(
  undefined
)
